import { render, staticRenderFns } from "./CreateSttServiceConfiguration.vue?vue&type=template&id=7007d71c&"
import script from "./CreateSttServiceConfiguration.vue?vue&type=script&lang=js&"
export * from "./CreateSttServiceConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports